<ion-app>
  <pos-menu></pos-menu>
  <ion-router-outlet id="menu-view"></ion-router-outlet>
</ion-app>